import React, { useState, useRef } from "react";
import { MdLockOutline } from "react-icons/md";
import { Modal } from 'bootstrap';

const TransactionPinModal = ({ id, onSubmit, title = "Enter Transaction PIN", description = "Enter your 4-digit PIN to securely proceed." }) => {
  const [pin, setPin] = useState(new Array(4).fill(""));
  const [isVerifying, setIsVerifying] = useState(false);
  const inputRefs = useRef([]);

  const handleInput = (e, index) => {
      const { value } = e.target;
      if (/^[0-9]$/.test(value)) {
          const newPin = [...pin];
          newPin[index] = value;
          setPin(newPin);
          
          if (index < 3) {
              inputRefs.current[index + 1]?.focus();
          }
      } else if (value === "") {
          const newPin = [...pin];
          newPin[index] = "";
          setPin(newPin);
      }
  };

  const handleKeyDown = (e, index) => {
      if (e.key === 'Backspace') {
          if (!pin[index] && index > 0) {
              const newPin = [...pin];
              newPin[index - 1] = "";
              setPin(newPin);
              inputRefs.current[index - 1]?.focus();
          }
      }
  };

  const hideModal = () => {
    const modalEl = document.getElementById(id);
    const modal = Modal.getInstance(modalEl);
    if (modal) {
        modal.hide();
    }
    
    // Clean up modal backdrop manually to prevent lingering overlay during navigation
    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    const backdrops = document.querySelectorAll('.modal-backdrop');
    backdrops.forEach(backdrop => backdrop.remove());
  };

  const handlePinSubmit = async () => {
    const currentPin = pin.join("");
    
    if (onSubmit) {
        const result = onSubmit(currentPin);
        if (result && typeof result.then === 'function') {
            setIsVerifying(true);
            try {
                await result;
            } finally {
                setIsVerifying(false);
                hideModal();
                setPin(new Array(4).fill(""));
            }
        } else {
            hideModal();
            setPin(new Array(4).fill(""));
        }
    } else {
        hideModal();
        setPin(new Array(4).fill(""));
    }
  };

  return (
    <section className="modal fade" id={id} tabIndex="-1" aria-labelledby={`${id}Label`} aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content border-0 shadow-lg rounded-4 overflow-hidden pb-4">
                <div className="d-flex justify-content-end p-3 position-absolute top-0 end-0 z-1">
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body p-4 p-md-5">
                    <div className="text-center mb-4 mt-2">
                        <div className="icon-wrapper mx-auto mb-3 d-flex align-items-center justify-content-center rounded-circle" style={{ width: '64px', height: '64px', backgroundColor: '#eff6ff', color: '#2563eb' }}>
                            <MdLockOutline size={32} />
                        </div>
                        <h4 className="mb-2 fw-bold text-dark">{title}</h4>
                        <p className="text-muted small px-3">{description}</p>
                    </div>
                    <div className="form-group mb-4 mt-4">
                        <div className="otp-input-container mx-auto d-flex justify-content-center gap-3">
                            {pin.map((digit, index) => (
                                <input
                                    key={index}
                                    type="password"
                                    maxLength={1}
                                    value={digit}
                                    className="form-control pin-input text-center fs-3 fw-bold rounded-3 border-2 shadow-sm p-0"
                                    onChange={(e) => handleInput(e, index)}
                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                    ref={(el) => inputRefs.current[index] = el}
                                    inputMode="numeric"
                                    autoComplete="one-time-code"
                                />
                            ))}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center mt-5">
                        <button 
                            className="btn primary__btn w-100 py-3 rounded-3 fw-semibold shadow-sm" 
                            onClick={handlePinSubmit} 
                            disabled={pin.join('').length !== 4 || isVerifying}
                        >
                            {isVerifying ? (
                                <div className="spinner-border spinner-border-sm text-light" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            ) : (
                                "Verify PIN"
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
  );
};

export default TransactionPinModal;
